<template>
	<div id="worksheetTab" class="page-navbar">
		<mt-navbar class="page-part" v-model="selected" id="tabHeader" :fixed="fixed">
	      <mt-tab-item id="1">最新工单</mt-tab-item>
	      <mt-tab-item id="2">处理中</mt-tab-item>
	      <mt-tab-item id="3">已解决</mt-tab-item>
	    </mt-navbar>
	    <form class="search-area" action="" onsubmit="return false;">
			<mt-search v-model="orderName" @keyup.native.enter="search" placeholder='请输入工单标题或设备名称、IP地址进行搜索'></mt-search>
		</form>
		<div id="worksheetCont" style="overflow: auto;">
			<mt-tab-container v-model="selected">
			<mt-tab-container-item :id="''+n" v-for="n in 3">
				<mt-loadmore :bottom-method="loadBottom" :top-method="loadTop"  :auto-fill="autoFill" :bottom-all-loaded="allLoadedParams['allLoaded'+n]" :ref="'loadmore'+n" bottomPullText="上拉加载更多" topLoadingText="加载中.." bottomDropText="释放加载">
						<div class="oneList" v-for="(item,index) in data[n-1]" @click="showDetail(item,n)">
							<div class="listTit" :class="index%3===0?'titCol1':(index%3===1?'titCol2':'titCol3')">{{item.title}}</div>
							<div class="listCont">
								<div>
									<div>设备名称：</div><div class="rightCol">{{item.deviceName}}</div>
								</div>
								<div>
									<div>IP地址：</div><div class="rightCol">{{item.deviceIp}}</div>
								</div>
								<div>
									<div>创建时间：</div><div class="rightCol">{{item.createTime}}</div>
								</div>	
							</div>
						</div>
				</mt-loadmore>
			</mt-tab-container-item>
			</mt-tab-container>
		</div>
	</div>
</template>

<script>
	import {_api} from '@/service/interface'
	export default{
		name:'WcNavbar',
		data(){
			return{
				fixed:true,
				selected: "1",
				orderName:'',
				autoFill:false,
				allLoadedParams:{
					allLoaded1:false,
					allLoaded2:false,
					allLoaded3:false
				},
				
				startSize:[0,0,0],
				pageCount:50,
				markList:['','NewestOrders','HandleOrders','SolveOrders'],
				data:[[],[],[]],
				deviceIp:null,
				selectedFlag:true,
				/*data:[[
					{
						"title":"最新WMAC_CLIENT_GOES_OFFLINE",
						"workNum":"20181022000001000025",
						"createTime":"2018-10-22 00:02:09",
						"operator":"郭铁军"
					},
					{
						"title":"最新WMAC_CLIENT_GOES_OFFLINE",
						"workNum":"20181114000001000045",
						"createTime":"2018-11-14 13:24:42",
						"operator":"郭铁军"
					},
					{
						"title":"最新WMAC_CLIENT_GOES_OFFLINE",
						"workNum":"20181114000001000044",
						"createTime":"2018-11-14 13:23:37",
						"operator":"郭铁军"
					},
					{
						"title":"最新WMAC_CLIENT_GOES_OFFLINE",
						"workNum":"20181114000001000043",
						"createTime":"2018-11-14 13:13:26",
						"operator":"郭铁军"
					},
					{
						"title":"最新WMAC_CLIENT_GOES_OFFLINE",
						"workNum":"20181114000001000044",
						"createTime":"2018-11-14 13:23:37",
						"operator":"郭铁军"
					},
					{
						"title":"最新WMAC_CLIENT_GOES_OFFLINE",
						"workNum":"20181114000001000043",
						"createTime":"2018-11-14 13:13:26",
						"operator":"郭铁军"
					},
				],[
					{
						"title":"处理中WMAC_CLIENT_GOES_OFFLINE",
						"workNum":"201837462798397907283",
						"createTime":"2018-02-12 09:31:12",
						"operator":"郭铁军"
					},
					{
						"title":"处理中WMAC_CLIENT_GOES_OFFLINE",
						"workNum":"201837462798397907283",
						"createTime":"2018-02-12 09:32:12",
						"operator":"郭铁军"
					},
					{
						"title":"处理中WMAC_CLIENT_GOES_OFFLINE",
						"workNum":"201837462798397907283",
						"createTime":"2018-02-12 09:33:12",
						"operator":"郭铁军"
					},
					{
						"title":"处理中WMAC_CLIENT_GOES_OFFLINE",
						"workNum":"201837462798397907283",
						"createTime":"2018-02-12 09:34:12",
						"operator":"郭铁军"
					},
					{
						"title":"处理中WMAC_CLIENT_GOES_OFFLINE",
						"workNum":"201837462798397907283",
						"createTime":"2018-02-12 09:35:12",
						"operator":"郭铁军"
					},
					{
						"title":"处理中WMAC_CLIENT_GOES_OFFLINE",
						"workNum":"201837462798397907283",
						"createTime":"2018-02-12 09:36:12",
						"operator":"郭铁军"
					}
				],[
					{
						"title":"已解决WMAC_CLIENT_GOES_OFFLINE",
						"workNum":"20181022000001000025",
						"createTime":"2018-10-22 00:02:09",
						"operator":"郭铁军"
					},
					{
						"title":"已解决WMAC_CLIENT_GOES_OFFLINE",
						"workNum":"20181114000001000045",
						"createTime":"2018-11-14 13:24:42",
						"operator":"郭铁军"
					},
					{
						"title":"已解决WMAC_CLIENT_GOES_OFFLINE",
						"workNum":"20181114000001000044",
						"createTime":"2018-11-14 13:23:37",
						"operator":"郭铁军"
					},
					{
						"title":"已解决WMAC_CLIENT_GOES_OFFLINE",
						"workNum":"20181114000001000043",
						"createTime":"2018-11-14 13:13:26",
						"operator":"郭铁军"
					},
					{
						"title":"已解决WMAC_CLIENT_GOES_OFFLINE",
						"workNum":"20181114000001000044",
						"createTime":"2018-11-14 13:23:37",
						"operator":"郭铁军"
					},
					{
						"title":"已解决WMAC_CLIENT_GOES_OFFLINE",
						"workNum":"20181114000001000043",
						"createTime":"2018-11-14 13:13:26",
						"operator":"郭铁军"
					},
				]],*/
			}
		},
		methods:{
			calculateHeight(){
				//获取workPage的高度，不包括底部导航栏
				var workPageH = document.getElementById("worksheetPage").clientHeight;
				//获取tabHeader的高度
				var tabH = document.getElementById("tabHeader").clientHeight;
				//tab的内容区的高度为
				var tabCont = document.getElementById("worksheetCont");
				//var loadDiv=this.$el.querySelector(".mint-tab-container-wrap");
				tabCont.style.height = workPageH-tabH-100+"px";
				//loadDiv.style.minHeight = workPageH-tabH-100+"px";
			},
			loadBottom1(){},
			loadBottom(){
				//加载更多数据
				this.startSize[this.selected-1]+=this.pageCount;
				//在这个方法的最后需要手动调用loadmore的onTopLoaded事件。这是因为在加载数据后需要对组件进行一些重新定位的操作。
				this.getWorkSheetList(this.selected,(flag)=>{
					this.allLoadedParams['allLoaded'+this.selected] = true;
					this.$refs['loadmore'+this.selected][0].onBottomLoaded();
					if(flag){
						setTimeout(()=>{
							this.allLoadedParams['allLoaded'+this.selected] = false;
						},2000)
					}
				})
			},
			loadTop(){
				//加载更多数据
				this.startSize[this.selected-1]=0;
				//在这个方法的最后需要手动调用loadmore的onTopLoaded事件。这是因为在加载数据后需要对组件进行一些重新定位的操作。
				this.getWorkSheetList(this.selected,(flag)=>{
					//this.allLoadedParams['allLoaded'+this.selected] = true;
					this.$refs['loadmore'+this.selected][0].onTopLoaded();
					/*if(flag){
						setTimeout(()=>{
							this.allLoadedParams['allLoaded'+this.selected] = false;
						},2000)
					}*/
				},true)
			},
			search(){
				this.startSize[this.selected-1]=0;
				this.getWorkSheetList(this.selected,()=>{},true)
			},
			getCurSelectedId(){
				setTimeout(()=>{
					if(this.$route.query.selected){
						this.selected=''+this.$route.query.selected
					}
					if(this.$route.query.deviceIp){
						this.deviceIp=this.$route.query.deviceIp
					}
					if(this.$route.query.name){
						this.orderName=this.$route.query.name
					}
					this.getWorkSheetList(this.selected);
					//this.getOtherSheetList();
				},10);
				console.log("hhddddddddddddddddddddddddddddddddd",this.$route)
			},
			showDetail(item,n){
				let url="/detailWorksheet?id="+item.workNum+'&selected='+this.selected;
				if(this.orderName.trim()){
					url+='&name='+this.orderName.trim()
				}
				if(this.$route.query.deviceIp){
					url+='&ip='+this.$route.query.deviceIp
				}
				if(this.$route.query.str){
					url+='&str='+this.$route.query.str
				}
				this.$router.push(url)
			},
			getOtherSheetList(){
				let arr=[1,2,3];
				arr.splice(this.selected-1,1);
				arr.forEach(item=>{
					this.getWorkSheetList(item)
				})
			},
			//获取当前选项的所有工单
			getWorkSheetList(index,sc,rebuild){
				let data={mark:this.markList[index],startSize:this.startSize[index-1],pageCount:this.pageCount,deviceIp:this.deviceIp,orderName:this.orderName.trim()};
				_api('_order','.code',{params:data},res=>{
					if(rebuild){
						this.data[index-1].splice(0,this.data[index-1].length)
					}
					if(res.data.orderList){
						res.data.orderList.forEach(item=>{
							this.data[index-1].push({
								title:item.orderName,
								workNum:item.orderId,
								deviceIp:item.deviceIp,
								deviceName:item.deviceName,
								createTime:item.orderCreateTime
							})
						})
						sc&&sc(true);
					}else{
						sc&&sc(false);
					}
					this.selectedFlag=!1;
				},err=>{
					
				})
			}
			
		},
		mounted() {
			this.$nextTick(()=>{
				this.calculateHeight();
			})
			
			this.getCurSelectedId();
			
		},
		watch:{
			selected(){
				if(!this.selectedFlag){
					this.orderName='';
					this.startSize[this.selected-1]=0;
					this.getWorkSheetList(this.selected,()=>{},true)
				}
			}
		}
	}
</script>

<style>
	#worksheetTab .mint-navbar.is-fixed{
		top:45px;
		z-index: 11;
	}
	
	#worksheetCont{
		margin-top: 90px;
		-webkit-overflow-scrolling: touch;
	}
	#worksheetPage .oneList{
		width: 100%; 
		height: 120px; 
		margin-top: 20px;
		background: #FFFFFF;
		border-bottom: 1px solid #DCDCDC;
		box-shadow: 2px 2px 10px #DDDDDD;
	}
	.search-area{
		height: 50px;
	    z-index: 12;
	    position: fixed;
	    width: 100%;
	    top: 85px;
	    background: #f3f3f3;
	}
	#worksheetPage .listTit{
		width: 130px;
	    height: 35px;
	    background: #029DCD;
	    position: relative;
	    top: -10px;
	    z-index: 9;
	    border-bottom-right-radius: 30px;
	    border-top-right-radius: 30px;
	    color: #FFFFFF;
	    font-size: 16px;
	    line-height: 35px;
	    padding-left: 15px;
		padding-right: 15px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	#worksheetPage .listCont{
		width: 100%;
	    height: 90px;
	    background: #FFFFFF;
	    position: relative;
	    top: -8px;
	    
	}
	#worksheetPage .listCont>div{
		padding: 5px 15px;
		display: flex;
		justify-content: space-between;
		color: #7F7F7F;
		font-size: 14px;
	}
	#worksheetPage .rightCol{
		color: #484848;
	}
	#worksheetPage .titCol1{
		background:#029DCD;
	}
	#worksheetPage .titCol2{
		background:#02AEC4;
	}
	#worksheetPage .titCol3{
		background:#00C8BD;
	}
	#worksheetTab .mint-search{
		height: 100%;
	}
</style>


// WEBPACK FOOTER //
// src/components/worksheet/worksheetTab/WcNavbar.vue